// extracted by mini-css-extract-plugin
export default {"resource-group-view":"ResourceGroupView_resource-group-view__hiNYR","collapsed":"ResourceGroupView_collapsed__+XFze"};